import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Changelog16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path d='M7.5 3.75H15.5V2.25H7.5V3.75Z' fill='currentColor' />
    <path
      d='M1.53039 6.96967L0.469727 8.03033L3.00006 10.5607L5.53039 8.03033L4.46973 6.96967L3.75 7.68939V5C3.75 4.30964 4.30964 3.75 5 3.75H6V2.25H5C3.48122 2.25 2.25 3.48122 2.25 5V7.68928L1.53039 6.96967Z'
      fill='currentColor'
    />
    <path d='M1.5 13.75H4.5V12.25H1.5V13.75Z' fill='currentColor' />
    <path d='M15.5 8.75L7.5 8.75V7.25L15.5 7.25V8.75Z' fill='currentColor' />
    <path d='M7.5 13.75H15.5V12.25H7.5V13.75Z' fill='currentColor' />
  </Svg>
);

Changelog16.displayName = 'Changelog16';
export default Changelog16;
